/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';

export const recordAttributionV1ResponseDataSchema = z.object({
  recorded: z.boolean(),
});

export type IRecordAttributionV1ResponseData = z.infer<
  typeof recordAttributionV1ResponseDataSchema
>;

export const recordAttributionV1ResponseSchema = createApiResponseSchema(
  recordAttributionV1ResponseDataSchema,
) as z.ZodSchema<IAPI<IRecordAttributionV1ResponseData>>;

export type IRecordAttributionV1Response = IAPI<IRecordAttributionV1ResponseData>;
